import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getBetaAllowlist,
  addToBetaAllowlist,
  removeFromBetaAllowlist,
} from '@/api/betaAllowlistService';
import { queryKeys } from '@/lib/queryKeys';
import { toaster } from '@/components/ui/toaster';

export const useBetaAllowlist = () => {
  const queryClient = useQueryClient();

  const { data: entries = [], isLoading, error } = useQuery({
    queryKey: queryKeys.betaAllowlist,
    queryFn: getBetaAllowlist,
    staleTime: 30 * 1000,
  });

  const invalidate = () => queryClient.invalidateQueries({ queryKey: queryKeys.betaAllowlist });

  const addEmailMutation = useMutation({
    mutationFn: addToBetaAllowlist,
    onSuccess: (data) => {
      invalidate();
      if (data.entries && Array.isArray(data.entries)) {
        toaster.create({ title: `${data.entries.length} email(s) ajouté(s)`, type: 'success' });
      } else if (data.entry) {
        toaster.create({ title: 'Email ajouté', type: 'success' });
      }
    },
    onError: (err) => {
      toaster.create({
        title: "Échec de l'ajout",
        description: err instanceof Error ? err.message : 'Une erreur est survenue',
        type: 'error',
      });
    },
  });

  const removeEmailMutation = useMutation({
    mutationFn: removeFromBetaAllowlist,
    onSuccess: () => {
      invalidate();
      toaster.create({ title: 'Email retiré', type: 'success' });
    },
    onError: (err) => {
      toaster.create({
        title: 'Échec de la suppression',
        description: err instanceof Error ? err.message : 'Une erreur est survenue',
        type: 'error',
      });
    },
  });

  return {
    entries,
    isLoading,
    error,
    addEmail: addEmailMutation.mutate,
    isAdding: addEmailMutation.isPending,
    removeEmail: removeEmailMutation.mutate,
    isRemoving: removeEmailMutation.isPending,
  };
};
